import { useEffect, useState } from "react"
import { Card, CardBody, Container } from "reactstrap"
import withRouter from "Components/Common/withRouter"
import Breadcrumb from "Components/organisms/breadcrumb"
import MarkdownViewer from "Components/molecule/markdown-viewer"
import LoadingState from "Components/organisms/loading-state"
import { PublishedMemo } from "models/memo"
import { getPublishedMemos } from "slices/admin/memos/thunk"

// Route: /version-log. Every user; only memos already sent to everyone, newest first.
// Not linked from the menu yet (reachable by URL only).
const VersionLogPage = () => {
    document.title = "Version Log | IbexIQ";
    const [notes, setNotes] = useState<PublishedMemo[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        const init = async () => {
            setNotes(await getPublishedMemos() ?? [])
            setIsLoading(false)
        }
        init()
    }, [])

    return (
        <div className="page-content">
            <Container fluid style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <Breadcrumb title="IbexIQ" breadcrumbItem="Version Log" />

                {isLoading && <LoadingState title="Loading version log" />}

                {!isLoading && notes.length === 0 && (
                    <p className="text-muted">No updates published yet.</p>
                )}

                {!isLoading && notes.map(note => (
                    <Card key={note.slug}>
                        <CardBody>
                            <h4 className="mb-1">{note.title}</h4>
                            <p className="text-muted mb-2">
                                <i className="bx bx-calendar me-1"></i>
                                {note.periodEnd ?? note.publishedAt.slice(0, 10)}
                            </p>
                            {note.summary && <p>{note.summary}</p>}
                            <MarkdownViewer content={note.content} />
                        </CardBody>
                    </Card>
                ))}
            </Container>
        </div>
    )
}

export default withRouter(VersionLogPage)
